import { render } from "./FileSearchCriteria.vue?vue&type=template&id=9d1fc3a6"
import script from "./FileSearchCriteria.vue?vue&type=script&lang=js"
export * from "./FileSearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__